import adminApi from "./adminApi";

export async function getDashboardStats() {
  const response = await adminApi.get("/admin/stats");

  return response.data.stats;
}